import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Grid, TextField, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import api from "../../services/api";
import { toast } from "../../utils/toast";
import toastError from "../../errors/toastError";

const labels = {
  GROQ_API_KEY: "Chave da API Groq",
  GROQ_MODEL: "Modelo Groq principal",
  GROQ_LIGHT_MODEL: "Modelo Groq para tarefas leves",
  PROSIPE_HELPDESK_INTEGRATIONS_JSON: "Integrações Helpdesk por empresa/fila (JSON)",
  PROSIPE_HELPDESK_ALLOWED_HOST_SUFFIXES: "Domínios permitidos do Helpdesk",
  PROSIPE_HELPDESK_LLM_SHADOW_ENABLED: "Classificação em modo sombra (true/false)",
  PROSIPE_HELPDESK_LLM_MODEL: "Modelo da classificação Helpdesk"
};

const IntegrationSettings = () => {
  const [settings, setSettings] = useState([]);
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/integration-settings").then(({ data }) => {
      setSettings(data);
      setValues(Object.fromEntries(data.map(item => [item.key, item.value || ""])));
    }).catch(toastError).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setLoading(true);
    try {
      const { data } = await api.put("/integration-settings", { values });
      setSettings(data.settings);
      setValues(Object.fromEntries(data.settings.map(item => [item.key, item.value || ""])));
      toast.success("Configurações de integração salvas com segurança.");
    } catch (error) { toastError(error); }
    finally { setLoading(false); }
  };

  if (loading && !settings.length) return <CircularProgress />;
  return <Grid container spacing={2}>
    <Grid item xs={12}><Alert severity="warning">Disponível apenas para superadministrador. Segredos são mascarados; deixe o campo vazio para preservar o valor atual.</Alert></Grid>
    {settings.map(item => <Grid item xs={12} key={item.key}>
      <TextField fullWidth variant="outlined" label={labels[item.key] || item.key}
        type={item.secret ? "password" : "text"} multiline={item.key.endsWith("_JSON")} rows={item.key.endsWith("_JSON") ? 5 : undefined}
        value={values[item.key] || ""} placeholder={item.secret && item.configured ? "Configurado — deixe vazio para preservar" : ""}
        helperText={item.secret ? (item.configured ? "Segredo configurado e não exibido." : "Ainda não configurado.") : item.key}
        onChange={event => setValues(current => ({ ...current, [item.key]: event.target.value }))} />
    </Grid>)}
    <Grid item xs={12}><Button color="primary" variant="contained" disabled={loading} onClick={save}>Salvar integrações</Button></Grid>
    <Grid item xs={12}><Typography variant="caption">Valores passam a valer imediatamente nesta API. Reinicie o worker após alterações para que o processo separado também recarregue as configurações.</Typography></Grid>
  </Grid>;
};

export default IntegrationSettings;
